// src/pages/MainDashboard.js
import React from 'react';
import Navbar from '../components/main/Navbar'; // Import the Navbar component
import Footer from '../components/main/Footer'; // Import the Footer component
import '../assets/styles/DashBoard.css'; // Corrected import statement
import { features } from '../utilities/ArrayHelper/Main';
import patientImage from '../assets/images/MainImg.jpeg'; // Import your image

const MainDashboard = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      {/* <Navbar />  */}

      <div className="text-center bg-light py-3 " style={{ marginTop: '60px' }}>
        <h1 className="display-4 fw-bold pickcolor">MAGUNEX</h1>
        <p className="lead text-secondary">
          Cloud software for Clinic Operations and Management
        </p>
      </div>

      {/* Card section */}
      <div className="container-fluid py-5">
        <div className="row text-center">
          {features.map((feature, index) => (
            <div className="col-md-4 col-lg-3 mb-4" key={index}>
              <div className="card h-100 shadow-sm border-0 p-3">
                <div className="card-body p-4">
                  <h5 className="card-title pi mb-3">{feature.title}</h5>
                  <p className="card-text">{feature.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* New Section */}
      {/* Patient Info Section */}
      {/* Patient Info Section */}
      <div className="mx-auto  py-0" style={{ width: '90vw' }}>
  <div className="d-flex flex-wrap align-items-center bg-white shadow rounded-4 p-4">
    
    {/* Text Column - 70% */}
    <div className="mb-4 mb-md-0" style={{ width: '60%' }}>
      <div className="pe-md-4">
        <h3 className="mb-4 fw-bold pickcolor">Why Choose Magunex?</h3>
        <p>We understand that efficient patient management is crucial for healthcare providers.</p>
        <p>
          <strong>Comprehensive Patient Management:</strong> Manage records, appointments, and billing with ease.
        </p>
        <p>
          <strong>User-Friendly Interface:</strong> Designed for quick navigation and minimal training.
        </p>
        <p>
          <strong>Real-Time Access:</strong> Always have the most accurate patient data at your fingertips.
        </p>
        <p>
          <strong>Secure & Compliant:</strong> Robust protection for sensitive patient data.
        </p>
        <p>
          <strong>Integrated Communication:</strong> Message your team and send patient reminders seamlessly.
        </p>
        <p className="mb-0">Experience the difference a modern Patient Information System makes.</p>
      </div>
    </div>

    {/* Image Column - 30% */}
    <div className="d-flex justify-content-center" style={{ width: '40%' }}>
      <div className="rounded-4 overflow-hidden shadow-sm w-100">
        <img
          src={patientImage}
          alt="Patient Management"
          className="img-fluid w-100"
          style={{ maxHeight: '500px', objectFit: 'cover' }}
        />
      </div>
    </div>

  </div>
</div>
      {/* <Footer />  */}
    </div>
  );
};

export default MainDashboard;